import type React from 'react';

export enum VideoLength {
  FULL_8S = '8',    // 8초 전체 스토리 (1개 세그먼트)
  FULL_16S = '16',  // 16초 전체 스토리 (2개 세그먼트)
  FULL_24S = '24',  // 24초 전체 스토리 (3개 세그먼트)
  CUSTOM = 'custom', // 사용자 정의 길이
}

export type VideoLengthValue = VideoLength | number;

export enum StoryLanguage {
  KOREAN = 'ko',
  ENGLISH = 'en',
  JAPANESE = 'ja',
  CHINESE = 'zh',
  SPANISH = 'es',
  FRENCH = 'fr',
  GERMAN = 'de',
  RUSSIAN = 'ru',
}

export enum StoryStructure {
  HOOK_TO_END = 'hook_to_end',        // 끝까지 보게 되는 강력한 훅
  DRAMATIC_TWIST = 'dramatic_twist',   // 극적인 반전
  EMOTIONAL_JOURNEY = 'emotional',     // 감동적인 여정
  COMEDY_BUILDUP = 'comedy',          // 코미디 빌드업
  MYSTERY_REVEAL = 'mystery',         // 미스터리와 해답
  TUTORIAL_STEPS = 'tutorial',        // 단계별 튜토리얼
  BEFORE_AFTER = 'before_after',      // 비포/애프터 변화
  CHALLENGE_RESULT = 'challenge',     // 도전과 결과
  FACTS_SURPRISE = 'facts',           // 놀라운 사실들
  STORY_LOOP = 'loop',                // 순환 구조 스토리
}

export interface StoryInputFormProps {
  onGenerate: (topic: string, length: VideoLength | number, language: StoryLanguage, structure: StoryStructure) => void;
  isLoading: boolean;
}

export interface ScriptDisplayProps {
  script: string;
  onGenerateVideo: () => void;
  isGeneratingVideo: boolean;
}

export interface VideoDisplayProps {
    videoUrl: string | null;
    isGeneratingVideo: boolean;
    videoError: string | null;
}

export interface LayoutProps {
    children: React.ReactNode;
}

export interface VideoSegment {
    segmentNumber: number;
    duration: number; // Always 8 seconds
    scriptContent: string;
    videoUrl?: string;
    transition?: string; // Transition text to next segment
}

export interface FullStoryVideo {
    totalDuration: number; // 8, 16, or 24 seconds
    segments: VideoSegment[];
    title: string;
    isSeamless: boolean; // Indicates if segments connect smoothly
}
